import { camelize } from 'casing'
import { EulaType } from '../types'

export const mapPrivateOffer = (offerItem: any, idKey: string) => {
  const { [idKey]: privateOfferId, eulaFiles, ...remainingOffer } = offerItem
  return {
    privateOfferId,
    eulaFile: eulaFiles ? [...(eulaFiles as string[])] : [],
    ...remainingOffer,
  }
}

export const mapSinglePrivateOffer = (
  data: any,
  idKey: string,
  cloudMarketplace: string
) => {
  const { eulaFiles, ...remainingOffer } = camelize(data)
  const commonData = {
    privateOfferId: remainingOffer[idKey],
    eulaFile: eulaFiles || [],
    ...remainingOffer,
  }
  if (cloudMarketplace === 'AZURE') {
    return {
      ...commonData,
      labraProductId:
        remainingOffer?.labraProductId ||
        remainingOffer?.cloudProductId ||
        remainingOffer?.cloud_product_id,
      awsProductId:
        remainingOffer?.awsProductId ||
        remainingOffer?.cloudProductId ||
        remainingOffer?.cloud_product_id,
      azurePricingType:
        remainingOffer?.plans?.length > 0
          ? remainingOffer?.plans[0].discountType
          : '',
      eulaType: (remainingOffer as any)?.eulaType || EulaType.STANDARD,
    }
  }
  return commonData
}
